<div id="divChart">
  <canvas id="canvas">{{ myChart }}</canvas>
</div>
